import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaceAvatarPlaceholderDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 128,
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 128,
			height: 128,
			rx: 24,
			fill: "white",
			fillOpacity: .08
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_31053_6295)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M86.3999 93.6C86.3999 92.2745 87.4744 91.2 88.7999 91.2C90.1254 91.2 91.1999 92.2745 91.1999 93.6V94.4H86.3999V93.6Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M88.8002 86.4L89.6002 89.6V93.6L87.2002 94.4L88.0002 89.6L87.2002 84L88.8002 86.4Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.9282 81.1597C93.6968 77.8039 90.9114 75.2 87.5477 75.2C87.4474 75.2 87.3454 75.2 87.2417 75.2C83.5372 75.2 83.0402 79.8008 83.2362 83.4858C83.3774 86.1391 85.7055 88 88.3625 88C91.6275 88 94.2092 85.2341 93.9845 81.9769L93.9282 81.1597Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.968 77.7683C92.8997 76.5478 91.089 76.3184 89.7515 77.236C89.1961 77.617 88.5091 78.0884 87.6594 78.6714C85.5742 80.1019 85.7522 81.7491 86.5076 83.08C87.5383 84.8958 89.9969 84.8291 91.7186 83.6479L93.3704 82.5146C94.9505 81.4305 95.2301 79.2102 93.968 77.7683Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.3694 80.968C83.4377 79.7476 85.2484 79.5182 86.5859 80.4358C87.1413 80.8168 87.8283 81.2882 88.678 81.8711C90.7632 83.3017 90.5852 84.9489 89.8297 86.2798C88.7991 88.0956 86.3405 88.0289 84.6188 86.8477L82.967 85.7143C81.3869 84.6303 81.1073 82.4099 82.3694 80.968Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.46 61.1193C78.6715 61.3481 78.7854 61.6506 78.7783 61.9621L78.0537 93.6272C78.0388 94.279 77.5065 94.8 76.8545 94.8H38.3457C37.6938 94.7999 37.1614 94.279 37.1465 93.6272L36.4219 61.9621C36.4148 61.6506 36.5297 61.3481 36.7412 61.1193L57.6006 38.5676L78.46 61.1193Z",
					stroke: "white",
					strokeWidth: 2.4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.0781 61.5969C78.1887 61.7169 78.25 61.8741 78.25 62.0373V92.6496H36.9502V62.0373C36.9502 61.8741 37.0115 61.7169 37.1221 61.5969L57.5996 39.382L78.0781 61.5969Z",
					stroke: "white",
					strokeWidth: 3.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.7998 81.6C52.7998 78.949 54.9488 76.8 57.5998 76.8C60.2508 76.8 62.3998 78.949 62.3998 81.6V96H52.7998V81.6Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.7998 44.8H75.1998V59.2L68.7998 52V44.8Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.5998,
					cy: 62.4,
					r: 4.8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32 95.2C32 93.8745 33.0745 92.8 34.4 92.8H93.6C94.9255 92.8 96 93.8745 96 95.2V96H32V95.2Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_31053_6295",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 64,
				height: 64,
				fill: "white",
				transform: "translate(32 32)"
			})
		}) })
	]
});
export default SvgPlaceAvatarPlaceholderDark;
